/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Badge_See_All_ChatsInputs */



/**
* | output |
* | --- |
* | "Sees everyone's chats" |
*
* @param {Projects_Badge_See_All_ChatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_badge_see_all_chats = /** @type {((inputs?: Projects_Badge_See_All_ChatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Badge_See_All_ChatsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sieht alle Chats")
	return /** @type {LocalizedString} */ ("Sees everyone's chats")
});